import React from 'react';
import { Box, Text, Button, Flex, Divider, useToast } from '@chakra-ui/react';
import {
  formatCOPDisplay,
  formatMaskedBankAccount,
  getBankAccountTypeLabel,
  getStudentShortName,
  formatIdentityNumber,
} from 'api/administrador/refunds';

const PURPLE = '#574feb';

function CopyButton({ value, toast }) {
  if (!value || value === '—') return null;

  return (
    <Button
      size="xs"
      bg="#E8E4FC"
      color={PURPLE}
      borderRadius="full"
      px={3}
      h="22px"
      minW="auto"
      fontSize="xs"
      fontWeight="medium"
      _hover={{ bg: '#D4CCF0' }}
      onClick={() => {
        navigator.clipboard.writeText(String(value));
        toast({ title: 'Copiado al portapapeles', status: 'success', duration: 2000, isClosable: true });
      }}
    >
      copiar
    </Button>
  );
}

function BankDetailRow({ label, value, copyValue, copiable, toast }) {
  return (
    <Flex justify="space-between" align="center" py={2} gap={3}>
      <Text fontSize="sm" color="gray.600" flexShrink={0}>
        {label}
      </Text>
      <Flex align="center" gap={2} pr={1} minW={0}>
        <Text fontSize="sm" fontWeight="bold" color="gray.800" textAlign="right">
          {value}
        </Text>
        {copiable && <CopyButton value={copyValue ?? value} toast={toast} />}
      </Flex>
    </Flex>
  );
}

export default function BankDetailsDisplay({ refund, showAmount = true }) {
  const toast = useToast();
  const student = refund.student;

  const titular = refund.bank_holder || getStudentShortName(student);
  const documento = refund.bank_document || formatIdentityNumber(student?.identity);
  const banco = refund.bank_name || '—';
  const tipo = refund.bank_account_type ? getBankAccountTypeLabel(refund.bank_account_type) : '—';
  const accountNumber = refund.bank_account_number || '';
  const cuentaDisplay = accountNumber ? formatMaskedBankAccount(accountNumber) : '—';

  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={4} mb={5} bg="white">
      <Text fontSize="xs" fontWeight="bold" color={PURPLE} letterSpacing="wider" textTransform="uppercase" mb={3}>
        Datos bancarios destino
      </Text>

      <BankDetailRow label="Titular" value={titular} copiable toast={toast} />
      <BankDetailRow
        label="Documento"
        value={documento}
        copyValue={documento !== '—' ? String(documento).replace(/\./g, '') : documento}
        copiable
        toast={toast}
      />
      <BankDetailRow label="Banco" value={banco} copiable={false} toast={toast} />
      <BankDetailRow label="Tipo" value={tipo} copiable={false} toast={toast} />
      <BankDetailRow
        label="Cuenta"
        value={cuentaDisplay}
        copyValue={accountNumber}
        copiable={!!accountNumber}
        toast={toast}
      />

      {showAmount && (
        <>
          <Divider borderStyle="dotted" borderColor="gray.300" my={2} />
          <Flex justify="space-between" align="center" py={2}>
            <Text fontSize="sm" color="gray.600">
              Monto
            </Text>
            <Text fontSize="sm" fontWeight="bold" color={PURPLE} pr={1}>
              {formatCOPDisplay(refund.refund_amount)}
            </Text>
          </Flex>
        </>
      )}
    </Box>
  );
}
